export default __webpack_public_path__ + "static/media/SF.b42e90db.png";